<script lang="ts" setup>
defineProps<{
  count: number
}>()
</script>

<template>
  <span class="count">{{ count }}</span>
</template>

<style lang="scss" scoped>
.count {
  font-size: 0.7rem;
  border-radius: 50%;
  width: rem-calc(18);
  height: rem-calc(18);
  display: inline-flex;
  align-items: center;
  justify-content: center;

  @include themify($themes) {
    background-color: themed('primaryColorLight');
    color: themed('primaryColor');
  }

  &.alert {
    background-color: $errorBgColor;
    color: $errorColor;
  }
}
</style>
